export default __webpack_public_path__ + "static/topIndustiesBg-7954eef63bd2a27acd102a154126d630.png";